import { render, staticRenderFns } from "./DialogPegaProduto.vue?vue&type=template&id=84ca8dac&"
import script from "./DialogPegaProduto.vue?vue&type=script&lang=js&"
export * from "./DialogPegaProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports